import { PlaceHolderImage } from '@/shared/assets'
import { useTmeInfoQuery } from '@/true-fsd/data/telegram'
import { type TelegramPeerDescriptor } from '@synapex/shared2/telegram'
import { Suspense } from 'react'
import { useInView } from 'react-intersection-observer'

type ChannelIconProps = {
    photoUrl?: string | null
    className?: string
} & Omit<TelegramPeerDescriptor, 'id'>

export const ChannelIcon = ({
    invite_hash,
    username,
    photoUrl,
    className,
}: ChannelIconProps) => {
    if (photoUrl) {
        return <img src={photoUrl} alt={'Channel Icon'} className={className} />
    }

    return (
        <Suspense
            fallback={
                <img
                    src={PlaceHolderImage}
                    className={className}
                    alt="Loading..."
                />
            }
        >
            <QueryChannelIcon
                {...{ invite_hash, username }}
                className={className}
            />
        </Suspense>
    )
}

const QueryChannelIcon = ({
    invite_hash,
    username,
    className,
}: ChannelIconProps) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '200px', // Load icons when they are 200px away from the viewport
    })

    const { data } = useTmeInfoQuery(
        { username, invite_hash },
        {
            enabled: inView,
        }
    )

    return (
        <img
            ref={ref}
            src={data?.smallPhoto || PlaceHolderImage}
            alt={data?.title || 'Channel Icon'}
            className={className}
        />
    )
}
